import React from 'react';
import css from './SectionComparison.module.css';

const ROWS = [
  { label: 'Monthly membership fee', gym: 'Yes — $50–$150/mo', gymnet: 'Never' },
  { label: 'Annual contract', gym: 'Yes — 12–24 months', gymnet: 'None' },
  { label: 'Cancellation fee', gym: 'Often $50–$200', gymnet: 'Free up to 24h' },
  { label: 'Pay only for sessions you use', gym: 'No', gymnet: 'Always' },
  { label: 'Trainer identity-verified', gym: 'Varies', gymnet: 'Every trainer' },
  { label: 'Satisfaction guarantee', gym: 'Rarely', gymnet: 'First session' },
];

const Check = () => (
  <svg aria-hidden="true" width="18" height="18" viewBox="0 0 24 24" fill="none" stroke="#0BB8FC" strokeWidth="2.5" strokeLinecap="round" strokeLinejoin="round">
    <polyline points="20 6 9 17 4 12" />
  </svg>
);

const Cross = () => (
  <svg aria-hidden="true" width="18" height="18" viewBox="0 0 24 24" fill="none" stroke="#bbb" strokeWidth="2.5" strokeLinecap="round" strokeLinejoin="round">
    <line x1="18" y1="6" x2="6" y2="18" />
    <line x1="6" y1="6" x2="18" y2="18" />
  </svg>
);

const SectionComparison = () => (
  <section className={css.root}>
    <div className={css.container}>
      <h2 className={css.title}>No Membership. Ever.</h2>
      <p className={css.subtitle}>
        The fitness industry was built on recurring contracts. GymNet was built to end them.
      </p>

      <div className={css.table} role="table" aria-label="GymNet vs. traditional gym comparison">
        <div className={css.thead} role="rowgroup">
          <div className={css.row} role="row">
            <div className={`${css.cell} ${css.labelCell}`} role="columnheader" />
            <div className={`${css.cell} ${css.gymCell}`} role="columnheader">
              <span className={css.gymLabel}>Big-box gym</span>
            </div>
            <div className={`${css.cell} ${css.gymnetCell}`} role="columnheader">
              <span className={css.gymnetLabel}>GymNet</span>
            </div>
          </div>
        </div>

        <div className={css.tbody} role="rowgroup">
          {ROWS.map((row, i) => (
            <div key={i} className={css.row} role="row">
              <div className={`${css.cell} ${css.labelCell}`} role="cell">{row.label}</div>
              <div className={`${css.cell} ${css.gymCell}`} role="cell">
                <Cross />
                <span>{row.gym}</span>
              </div>
              <div className={`${css.cell} ${css.gymnetCell}`} role="cell">
                <Check />
                <span>{row.gymnet}</span>
              </div>
            </div>
          ))}
        </div>
      </div>

      <a href="/s" className={css.cta}>Book your first session →</a>
    </div>
  </section>
);

export default SectionComparison;
